import 'bootstrap-css-only/css/bootstrap.min.css'
import '@fortawesome/fontawesome-svg-core/styles.css'
import 'mdbreact/dist/css/mdb.css'
import './src/styles/global.css'
import './src/styles/custom-icons.css'

export const onClientEntry = () => {
  const hash = window.location.hash;
  
  // Check specifically for invite or recovery tokens
  if (hash.includes("invite_token") || hash.includes("recovery_token")) {
    
    const script = document.createElement("script");
    script.src = "https://identity.netlify.com/v1/netlify-identity-widget.js";
    script.async = true;
    
    script.onload = () => {
      if (window.netlifyIdentity) {
        // This 'init' ensures the widget parses the URL hash immediately
        window.netlifyIdentity.on("init", user => {
          if (!user) {
            // If there's a token, this usually triggers the confirmation modal
            // but we call .open() to be certain the UI appears
            window.netlifyIdentity.open(); 
          }
        });

        // This handles the redirect once they set their password and are logged in
        window.netlifyIdentity.on("login", () => {
          document.location.href = "/admin/";
        });
      }
    };
    
    document.head.appendChild(script);
  }
};
